import { createSlice } from '@reduxjs/toolkit';
import { CONTRACT_TYPES } from 'constants.js';

const initialState = {
  caricamentoInCorso: false,
  contratti: [],
  opzioniTabella: { data: [], columns: [] },
  mostraOrdiniFatture: false,
  ordini: [],
  fatture: [],
  currentContratto: false,
  caricamentoModale: false,
  tipoModale: 'MOVIMENTI',
  contrattiFilter: CONTRACT_TYPES.TOTALE,
  tabellaSource: [],
};

const contrattiSlice = createSlice({
  name: 'contratti',
  initialState,
  reducers: {
    caricamento(state, action) {
      state.caricamentoInCorso = Boolean(action.payload);
    },
    aggiornaContratti(state, action) {
      state.contratti = action.payload;
    },
    aggiornaOpzioniTabella(state, action) {
      state.opzioniTabella = action.payload;
    },
    aggiornaContrattoAttuale(state, action) {
      state.currentContratto = action.payload;
    },
    mostraOrdiniFatture(state, action) {
      state.tipoModale = action.payload;
      state.mostraOrdiniFatture = true;
    },
    nascondiOrdiniFatture(state) {
      state.mostraOrdiniFatture = false;
    },
    aggiornaOrdini(state, action) {
      state.ordini = action.payload;
    },
    aggiornaFatture(state, action) {
      state.fatture = action.payload;
    },
    caricamentoModale(state, action) {
      state.caricamentoModale = Boolean(action.payload);
    },
    aggiornaTabellaSource(state, action) {
      state.tabellaSource = action.payload;
    },
    aggiornaContrattFilter(state, action) {
      state.contrattiFilter = action.payload;
    },
  },
});

export const {
  caricamento,
  aggiornaContratti,
  aggiornaOpzioniTabella,
  aggiornaContrattoAttuale,
  mostraOrdiniFatture,
  aggiornaOrdini,
  aggiornaFatture,
  caricamentoModale,
  nascondiOrdiniFatture,
  aggiornaTabellaSource,
  aggiornaContrattFilter,
} = contrattiSlice.actions;
const contrattiReducer = contrattiSlice.reducer;

export default contrattiReducer;
